import React from 'react';
import { Button } from '@shared/ui/button';
import {
  RefreshCw,
  MapPin,
  BarChart2,
  Upload,
  Download,
  Edit3,
  CheckCircle2,
  Wifi,
  Building2,
} from 'lucide-react';

interface QuickActionsProps {
  readType?: 'manual' | 'automated' | 'mobile';
  onAction?: (actionName: string) => void;
}

export const QuickActions: React.FC<QuickActionsProps> = ({
  readType = 'manual',
  onAction,
}) => {
  const getActions = () => {
    switch (readType) {
      case 'automated':
        return [
          { label: 'Sync Overview', icon: <BarChart2 className="w-4 h-4 text-gray-400" /> },
          { label: 'View Cycle', icon: <RefreshCw className="w-4 h-4 text-gray-400" /> },
          { label: 'Sync Now', icon: <Wifi className="w-4 h-4 text-gray-400" /> },
          { label: 'View Vendor', icon: <Building2 className="w-4 h-4 text-gray-400" /> },
          { label: 'Export Reads', icon: <Download className="w-4 h-4 text-gray-400" /> },
          { label: 'Add Notes', icon: <Edit3 className="w-4 h-4 text-gray-400" /> },
          { label: 'Mark Complete', icon: <CheckCircle2 className="w-4 h-4 text-gray-400" /> },
        ];
      case 'mobile':
        return [
          { label: 'View Cycle', icon: <RefreshCw className="w-4 h-4 text-gray-400" /> },
          { label: 'Estimate Reads', icon: <BarChart2 className="w-4 h-4 text-gray-400" /> },
          { label: 'Import Reads', icon: <Upload className="w-4 h-4 text-gray-400" /> },
          { label: 'Export Reads', icon: <Download className="w-4 h-4 text-gray-400" /> },
          { label: 'Add Notes', icon: <Edit3 className="w-4 h-4 text-gray-400" /> },
          { label: 'Mark Complete', icon: <CheckCircle2 className="w-4 h-4 text-gray-400" /> },
        ];
      case 'manual':
      default:
        return [
          { label: 'View Cycle', icon: <RefreshCw className="w-4 h-4 text-gray-400" /> },
          { label: 'View Routes', icon: <MapPin className="w-4 h-4 text-gray-400" /> },
          { label: 'Estimate Reads', icon: <BarChart2 className="w-4 h-4 text-gray-400" /> },
          { label: 'Import Reads', icon: <Upload className="w-4 h-4 text-gray-400" /> },
          { label: 'Export Reads', icon: <Download className="w-4 h-4 text-gray-400" /> },
          { label: 'Add Notes', icon: <Edit3 className="w-4 h-4 text-gray-400" /> },
          { label: 'Mark Complete', icon: <CheckCircle2 className="w-4 h-4 text-gray-400" /> },
        ];
    }
  };

  const actions = getActions();

  return (
    <div className="bg-white p-5 rounded-xl border border-gray-200 shadow-sm space-y-3">
      <h3 className="text-sm font-semibold text-gray-900 mb-2">Quick Actions</h3>
      <div className="flex flex-col space-y-1">
        {actions.map((action) => (
          <Button
            key={action.label}
            variant="outline"
            onClick={() => onAction?.(action.label)}
            className="w-full justify-start text-xs font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50 h-9 px-2.5 gap-2.5"
          >
            {action.icon}
            <span>{action.label}</span>
          </Button>
        ))}
      </div>
    </div>
  );
};
export default QuickActions;
